import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { defaultBenefit } from "@circle-react/helpers/paywallCustomizationHelpers";
import { useCheckoutTabContext } from "../../CheckoutTabContext";
import { localeRoot } from "../../constants";
import { BenefitForm } from "./Forms/BenefitForm";
import { TitleField } from "./Forms/BenefitForm/TitleField";
import { AddButton } from "./components/AddButton";
import { ContainerForm } from "./components/ContainerForm";
import { FormGroup } from "./components/FormGroup";
import { FormItemGroup } from "./components/FormItemGroup";

const dataTestId = "paywall-customization-benefit-container";
const toggleDataTestId = "paywall-customization-benefit-toggle";

export const BenefitProperties = () => {
  const { watch, getValues } = useFormContext();
  const { benefitPropertiesForm } = useCheckoutTabContext();

  const { fields, append, remove } = benefitPropertiesForm || {
    fields: [],
    append: () => {},
    remove: () => {},
  };

  const isEnabled = Boolean(
    watch("paywall_customization_attributes.benefit_properties.enabled"),
  );
  const hasReachedLimit = fields.length >= 10;
  const hasReachedMinimum = fields.length <= 1;
  const onAddItem = () => append(defaultBenefit);

  return (
    <ContainerForm
      titleLocale={t([localeRoot, "builder.benefits.show_benefits"])}
      toggleName="paywall_customization_attributes.benefit_properties.enabled"
      containerDataTestId={dataTestId}
      toggleDataTestId={toggleDataTestId}
    >
      <TitleField className="border-primary border-b px-6 pb-5" />
      <FormGroup isEnabled={isEnabled}>
        {fields.map((field, index: number) => {
          const formName = `paywall_customization_attributes.benefit_properties.benefits.${index}`;
          const onDuplicateClick = () => append(getValues(formName));
          const onRemoveClick = () => remove(index);

          return (
            <FormItemGroup
              key={field.id}
              index={index}
              fields={fields}
              hasReachedLimit={hasReachedLimit}
              hasReachedMinimum={hasReachedMinimum}
              onDuplicateClick={onDuplicateClick}
              onRemoveClick={onRemoveClick}
              title={t("item")}
              dataTestId="benefit-form-item-group"
            >
              <BenefitForm keyFormId={field.id} name={formName} />
            </FormItemGroup>
          );
        })}
      </FormGroup>
      <AddButton
        label={t([localeRoot, "builder.benefits.add_item"])}
        onClick={onAddItem}
        disabled={hasReachedLimit || !isEnabled}
        dataTestId="add-benefit-button"
      />
    </ContainerForm>
  );
};
